// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentCreatePrescriberResultModelResponse {
    static getAttributeTypeMap() {
        return EnrollmentCreatePrescriberResultModelResponse.attributeTypeMap;
    }
}
EnrollmentCreatePrescriberResultModelResponse.discriminator = undefined;
EnrollmentCreatePrescriberResultModelResponse.additionalProperties = false;
EnrollmentCreatePrescriberResultModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EnrollmentCreatePrescriberResultModel"
    },
];
//# sourceMappingURL=enrollmentCreatePrescriberResultModelResponse.js.map